function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.496 9.917a6.002 6.002 0 00-9.133-7.72 6 6 0 007.72 9.134l5.715 5.716 1.414-1.414-5.716-5.716zM9.434 3.612a4 4 0 11-5.657 5.657 4 4 0 015.657-5.657z",
  fill: "#A3A8AF"
});

function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSearchIcon;